import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState } from 'react';
import Footer from './components/Footer';
import Header from './components/Header';
import Home from './Home';
import Product from './Product';
import Sale from './Sale';
import Game from './Game';
import Cart from './Cart';
import ThankU from './ThankU';
import Profile from './Profile';
import ProfileInfo from './ProfileInfo';
import OrderHistory from './OrderHistory';
import OrderDetails from './OrderDetails';
import FavoriteList from './FavoriteList';
import OrderReview from './OrderReview';
import Socket from './Socket';

export default function App() {
    const [cartItems, setCartItems] = useState(JSON.parse(localStorage.getItem('cart')) || []);
    const [slidBarPOsition , setSlidBarPOsition] = useState("calc(100% / 3 *1)")
    const [profileActive, setProfileActive] = useState(null)
    return (
        <>
            <Router>
                <Header cartItems={cartItems} setSlidBarPOsition={setSlidBarPOsition} setProfileActive={setProfileActive} profileActive={profileActive}/>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/sale" element={<Sale />} />
                    <Route path="/game" element={<Game />} />
                    <Route path="/product" element={<Product {...{ cartItems, setCartItems }} />} />
                    <Route path="/cart" element={<Cart {...{ cartItems, setCartItems }} />} />
                    <Route path="/profile" 
                    element={<Profile 
                    setSlidBarPOsition={setSlidBarPOsition} 
                    slidBarPOsition={slidBarPOsition}
                    setProfileActive={setProfileActive} 
                    profileActive={profileActive}/>}>
                        <Route index element={<ProfileInfo />} />
                        <Route path="orderhistory" element={<OrderHistory />} />
                        <Route path="orderdetails" element={<OrderDetails />} >
                            <Route path="review" element={<OrderReview />}/>
                        </Route>
                        <Route path="favoritelist" element={<FavoriteList />} />
                    </Route>
                    <Route path="thanku" element={<ThankU />}/>
                    <Route path="socket" element={<Socket />}/>
                </Routes>
                <Footer />
            </Router>
        </>
    );
}
